<template>
  <page-layout :title="addNewProgram">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">{{ $t("program.program_info") }}</h4>
            </div>
          </md-card-header>

          <md-card-content>
            <validation-form @on-submit="addProgram">
              <!-- form input -->
              <div class="form-input mb-10">
                <div class="md-layout mt-15">
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <validation-field
                      :validations="program_validation.name"
                      name="name"
                    >
                      <label>{{ $t("program.filter_by_name") }}</label>
                      <md-input
                        required
                        v-model.trim="form.name"
                        :maxlength="program_validation.name.maxLength"
                      >
                      </md-input>
                      <span class="md-error" v-if="serverValidations.name">{{
                        serverValidations.name
                      }}</span>
                    </validation-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label :for="select.name">{{ select.label }}</label>
                      <md-select
                        :name="select.name"
                        :id="select.name"
                        v-model="form.status"
                        :multiple="select.multiple"
                      >
                        <!-- <md-option :value="''">--- All --</md-option> -->
                        <md-option
                          v-for="option in select.options"
                          :value="option.id"
                          :key="option.id + option.name"
                          >{{ option.name }}
                        </md-option>
                      </md-select>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-field>
                      <label>{{ $t("common.description") }}</label>
                      <md-input v-model="form.description"></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-33 md-small-size-100">
                    <md-checkbox
                      v-model="is_high_school_program"
                      @change="checkStatusProgram(is_high_school_program)"
                    >
                      {{ $t("program.high_school_program") }}
                    </md-checkbox>
                  </div>
                </div>
              </div>
              <!-- form select -->
              <div>
                <p class="ml-4 md-title mb-4">
                  {{ $t("program.progress_transcript") }}
                </p>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-33 md-small-size-100">
                  <md-field>
                    <label for="progress__">{{
                      $t("program.progress_report")
                    }}</label>
                    <md-select name="progress__" v-model="form.report_template">
                      <md-option
                        v-for="option in progressOption"
                        :value="option.id"
                        :key="option.id + option.name"
                        >{{ $t(option.name) }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                  v-if="form.report_template !== 'igs-prep'"
                >
                  <validation-field
                    :validations="{ required: true }"
                    name="transcript template"
                  >
                    <label for="transcript__"
                      >{{ $t("program.transcript_template")
                      }}<span class="text-[#F44336]"> *</span></label
                    >
                    <md-select
                      name="transcript__"
                      v-model="form.transcript_template"
                    >
                      <md-option
                        v-for="option in transcriptOption"
                        :value="option.id"
                        :key="option.id + option.name"
                        >{{ $t(option.name) }}
                      </md-option>
                    </md-select>
                  </validation-field>
                </div>
              </div>
              <div>
                <p class="ml-4 md-title mb-4">
                  {{ $t("program.select_graduation_category") }}
                </p>
              </div>
              <div class="md-layout">
                <div
                  class="md-layout-item  form-checkbox md-size-50 md-small-size-100"
                  v-for="(item, index) in graduationCategoryList"
                  :key="index"
                >
                  <md-checkbox
                    :disabled="item.status === 'Inactive'"
                    class="ml-4"
                    v-model="flagListRef[index]"
                    @change="cleanCreditInput(index)"
                  >
                    <md-tooltip
                      md-direction="top"
                      :class="hiddenTooltip(item.name, subName(item.name, 30))"
                      >{{ item.name }}
                    </md-tooltip>
                    <div class="checkbox-name">
                      {{ subName(item.name, 30) }}
                    </div>
                  </md-checkbox>
                  <validation-field
                    :validations="generateValidation(flagListRef[index])"
                    :name="`credit of ${subName(item.name, 10)}`"
                  >
                    <label>{{ $t("program.required_credit") }}</label>
                    <md-input
                      ref="graduationCategoryList"
                      :disabled="!flagListRef[index]"
                      :name="item.id.toString()"
                      v-model.trim="creditInput[index]"
                      :required="flagListRef[index]"
                    ></md-input>
                  </validation-field>
                </div>
              </div>
              <!-- btn -->
              <div class="from-submit">
                <md-button class="md-raised mr-5" @click="goToPreviousPage"
                  >{{ $t("common.cancel") }}
                </md-button>
                <md-button type="submit" class="md-success"
                  >{{ $t("common.add") }}
                </md-button>
              </div>
            </validation-form>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </page-layout>
</template>

<script>
import PageLayout from "../PageLayout.vue";
import { genErrMsgOj, hasHistory, Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import { validations } from "@/validations/programs";
import { program_router_names } from "@/routes/routes";
import cloneDeep from "lodash/cloneDeep";

const PROGRESS_OPTION = [
  // { id: "default", name: "survey.default" },
  { id: "standard", name: "program.standard" },
  { id: "honors", name: "subject.honors" },
  { id: "igs-prep", name: "program.igs_prep" }
];
const TRANSCRIPT_OPTION = [
  // { id: "default", name: "survey.default" },
  { id: "elementary school", name: "program.elementary_school" },
  { id: "middle school", name: "program.middle_school" },
  { id: "high school", name: "program.high_school" }
];

export default {
  components: { PageLayout },
  data() {
    const programInfo = {
      name: "",
      status: "Active",
      description: "",
      graduation_categories: [],
      status_student_program: "",
      report_template: null,
      transcript_template: null
    };

    return {
      program_validation: validations,
      serverValidations: {},
      //
      form: cloneDeep(programInfo),
      graduationCategoryList: null,
      flagListRef: [],
      creditInput: [],
      is_high_school_program: false,
      progressOption: PROGRESS_OPTION,
      transcriptOption: TRANSCRIPT_OPTION
    };
  },
  computed: {
    addNewProgram() {
      return this.$t("program.add_new_program");
    },
    select() {
      return {
        label: this.$t("program.filter_by_status"),
        name: "status__",
        value: "",
        type: "select",
        options: [
          {
            id: "Active",
            name: this.$t("common.active")
          },
          {
            id: "Inactive",
            name: this.$t("common.inactive")
          }
        ]
      };
    }
  },
  created() {
    this.$axios
      .get(`${service_paths.graduation_categories}`, { limit: 9999 })
      .then(response => {
        this.initGraduationCategory(response.data.data);
      })
      .catch(error => {
        console.log(error);
      });
  },
  watch: {
    "form.name": function() {
      this.serverValidations.name && delete this.serverValidations.name;
    },
    "form.report_template": function(template) {
      if (template === "igs-prep") this.form.transcript_template = null;
    }
  },
  methods: {
    checkStatusProgram(isHighSchoolProgram) {
      this.form.status_student_program = isHighSchoolProgram
        ? "High School"
        : "";
    },
    subName(name, maxLength) {
      if (name.length > maxLength) {
        return (
          name.slice(0, maxLength - 5) +
          (name.length > maxLength ? "..." : "") +
          name.slice(name.length - 5, name.length)
        );
      }
      return name;
    },
    hiddenTooltip(oldName, newName) {
      return oldName == newName ? "hidden-tooltip" : "";
    },
    cleanCreditInput(index) {
      this.creditInput[index] = "";
    },
    generateValidation(item) {
      return item ? this.program_validation.credit : {};
    },
    initGraduationCategory(data) {
      this.graduationCategoryList = data;
      const count = this.graduationCategoryList.length;
      this.flagListRef = Array(count).fill(false);
      this.creditInput = Array(count).fill("");
    },
    getSelectedGraduationCategory(graduationCategoryList) {
      const selectedList = graduationCategoryList.filter(item => {
        return !item.disabled;
      });
      let graduationCategories = selectedList.map(selectedItem => ({
        id: selectedItem.name,
        credit: selectedItem.model
      }));
      return graduationCategories;
    },
    addProgram() {
      const graduationCategoryList = this.$refs.graduationCategoryList;
      this.form.graduation_categories = this.getSelectedGraduationCategory(
        graduationCategoryList
      );
      // add
      const errMsg = this.$t("program.mess_form_invalid");
      this.$axios
        .post(service_paths.programs, this.form, true, {}, errMsg)
        .then(() => {
          Message.success(this.$t("common.add_success"));
          this.$router.push({ name: program_router_names.listPage });
        })
        .catch(error => {
          const errData = error.response?.data;
          if (errData) {
            const svErrMsgs = errData.messages;
            this.serverValidations = genErrMsgOj(svErrMsgs);
            console.log("this.serverValidations: ", this.serverValidations);
          }
        });
    },
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.form-checkbox {
  display: flex;
}

.md-checkbox {
  width: 300px;
}

.checkbox-name {
  color: gray;
  font-size: 16px;
  width: 170px;
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
}

.md-input {
  width: 220px;
}

.from-submit {
  display: flex;
  justify-content: center;
}

.md-error {
  top: 35px;
}

.md-title {
  font-size: 18px;
}

.hidden-tooltip {
  display: none;
}

.md-tooltip {
  overflow-wrap: break-word;
}
</style>
